import V2Text from '__pc__/components/common/v2Design/text';
import { SpaceValue } from '__pc__/constant/v2Design/SpaceType';
import { V2TextOption } from '__pc__/constant/v2Design/V2TextType';
import styled from 'styled-components';
import MatchMessageStore from 'models/MatchMessageStore';
import { FC } from 'react';
import { injectStore } from 'models/store';
import { inject, observer } from 'mobx-react';

const Frame = styled.div`
display: flex;
flex-direction: column;
padding:${SpaceValue.XL}px ${SpaceValue.L}px;
.desc{
    display: flex;
    white-space: pre-line;
    padding-bottom: 152px;
}
`;
interface IMatchApplySuggestMessageProps {
  matchMessageStore?: MatchMessageStore;
}
const MatchApplySuggestMessage: FC<IMatchApplySuggestMessageProps> = ({ matchMessageStore = new MatchMessageStore() }) => {
  return (
    <Frame>
      <V2Text fontStyle={V2TextOption.fontStyle.body_1_m} color={V2TextOption.color.default} className='desc'>
        {`${matchMessageStore.matchingMessage?.content}`}
      </V2Text>
    </Frame>
  );
};

export default inject(injectStore.matchMessageStore)(observer(MatchApplySuggestMessage));
